import { render, staticRenderFns } from "./UserPermissionsDialog.vue?vue&type=template&id=8bd32268&scoped=true"
import script from "./UserPermissionsDialog.vue?vue&type=script&lang=js"
export * from "./UserPermissionsDialog.vue?vue&type=script&lang=js"
import style0 from "./UserPermissionsDialog.vue?vue&type=style&index=0&id=8bd32268&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd32268",
  null
  
)

export default component.exports